import { getApolloClient } from '~/utils/apollo'
import getApplicationsQuery from '@/static/graphql/query-me-applications.graphql'

export const state = () => ({
  applications: undefined,
  features: {
    DASHBOARD_APPLICATIONS: process.env.DASHBOARD_APPLICATIONS === 'true',
  },
  loading: false,
})

export const mutations = {
  setApplications(state, payload) {
    const applications = payload.map((app) => {
      return { ...app, application: JSON.parse(app.application || '{}') }
    })
    state.applications = applications
  },
  setLoading(state, payload) {
    state.loading = payload
  },
}

export const actions = {
  async getApplications(context) {
    if (!context.state.features.DASHBOARD_APPLICATIONS) return

    const apollo = getApolloClient(this.app)

    try {
      context.commit('setLoading', true)
      const { data } = await apollo.query({ query: getApplicationsQuery })
      context.commit('setApplications', data.me.applications)
    } catch (error) {
      console.log(error.response)
      context.commit('setApplications', [])
    } finally {
      context.commit('setLoading', false)
    }
  },
}
